import { render } from "./B2bProfileContact.vue?vue&type=template&id=29999d8a&scoped=true&lang=pug"
import script from "./B2bProfileContact.vue?vue&type=script&lang=js"
export * from "./B2bProfileContact.vue?vue&type=script&lang=js"

import "./B2bProfileContact.vue?vue&type=style&index=0&id=29999d8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29999d8a"]])

export default __exports__